module.exports = __webpack_public_path__ + "static/media/tm1.a9cd5463.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ipd503/tm1.jpg
// module id = 178
// module chunks = 0